const ArrowLeftCircle: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 12C3.25 16.8325 7.16751 20.75 12 20.75C16.8325 20.75 20.75 16.8325 20.75 12C20.75 7.16751 16.8325 3.25 12 3.25C7.16751 3.25 3.25 7.16751 3.25 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.375 11.375C16.7202 11.375 17 11.6548 17 12C17 12.3452 16.7202 12.625 16.375 12.625H9.13375L11.8175 15.3075C11.9756 15.4656 12.0373 15.696 11.9795 15.912C11.9216 16.1279 11.7529 16.2966 11.537 16.3545C11.321 16.4123 11.0906 16.3506 10.9325 16.1925L7.1825 12.4425C7.06495 12.3252 6.99888 12.166 6.99888 12C6.99888 11.834 7.06495 11.6748 7.1825 11.5575L10.9325 7.8075C11.1769 7.56311 11.5731 7.56311 11.8175 7.8075C12.0619 8.05189 12.0619 8.44811 11.8175 8.6925L9.13375 11.375H16.375Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowLeftCircle;
